export default class SaveAlertHandler {
    private static _instance?: SaveAlertHandler;

    private constructor() {}

    private unloadHandler = (event: BeforeUnloadEvent) => {
        event.preventDefault();
    };

    public start() {
        window.addEventListener('beforeunload', this.unloadHandler);
    }

    public stop() {
        window.removeEventListener('beforeunload', this.unloadHandler);
    }

    public static get instance() {
        if (!this._instance) {
            this._instance = new SaveAlertHandler();
        }
        return this._instance;
    }
}
